module.exports = __webpack_public_path__ + "img/travel.7b76d91d.png";